import React from "react";
import { useEffect } from "react";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import Navbar from "./Navbar";
import NavbarStudents from "../Dashboard/Navbarlogedin";
import NavbarProfessionals from "../Interviewer/NavbarInterviewer";
import Footer from "./Footer";

const Pricing = () => {
  const user = JSON.parse(localStorage.getItem("isIAuthenticated"));
  return (
    <>
      {!user?.role ? <Navbar /> : null}
      {user?.role === "Student" ? <NavbarStudents /> : null}
      {user?.role === "Interviewer" ? <NavbarProfessionals /> : null}
      <div className="p-5" style={{ backgroundColor: "#f1c09d" }}>
        <Typography
          variant="h2"
          component="h2"
          sx={{ textAlign: "center", color: "#676df5", fontSize: "bold" }}
          gutterBottom
        >
          Pricing
        </Typography>
        <div className="flex flex-wrap gap-5 justify-center">
          <div
            className="rounded-md relative bg-white overflow-hidden"
            style={{ width: "300px", height: "300px" }}
          >
            <div
              className="text-center text-white"
              style={{ backgroundColor: "#6184d8" }}
            >
              <Typography variant="h4" gutterBottom>
                Uno
              </Typography>
            </div>
            <div className="p-3 text-center my-auto">
              <Typography variant="h6" gutterBottom>
                1 Mock Interview <br /> (with Live Feedback)
              </Typography>
            </div>
            <div className="text-center absolute bottom-2 left-1/2 -translate-x-1/2">
              <Chip label="INR 299" variant="outlined" color="primary" />
            </div>
          </div>
          <div
            className="rounded-md relative bg-white overflow-hidden"
            style={{ width: "300px", height: "300px" }}
          >
            <div
              className="text-center text-white"
              style={{ backgroundColor: "#89c152" }}
            >
              <Typography variant="h4" gutterBottom>
                Duo
              </Typography>
            </div>
            <div className="p-3 text-center my-auto">
              <Typography variant="h6" gutterBottom>
                2 Mock Interviews <br /> (with Live Feedback)
              </Typography>
            </div>
            <div className="text-center absolute bottom-2 left-1/2 -translate-x-1/2">
              <Chip label="INR 549" variant="outlined" color="success" />
            </div>
          </div>
          <div
            className="rounded-md relative bg-white overflow-hidden"
            style={{ width: "300px", height: "300px" }}
          >
            <div
              className="text-center text-white"
              style={{ backgroundColor: "#50c4b7" }}
            >
              <Typography variant="h4" gutterBottom>
                Trio
              </Typography>
            </div>
            <div className="p-3 text-center my-auto">
              <Typography variant="h6" gutterBottom>
                3 Mock Interviews <br /> (with Live Feedback)
              </Typography>
            </div>
            <div className="text-center absolute bottom-2 left-1/2 -translate-x-1/2">
              <Chip label="INR 799" variant="outlined" color="warning" />
            </div>
          </div>
        </div>
        <div className="text-justify mx-auto" style={{ width: "900px" }}>
          Payment can be made after acceptance of a Mock Interview Request
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Pricing;
